export const templatesData = [
  { id: 1, name: 'Default', description: 'Default Neoskool ID Template', templateClass: 'neo_default_id_template' },
]
